import { render, staticRenderFns } from "./MailLog.vue?vue&type=template&id=52d11521&scoped=true&"
import script from "./MailLog.vue?vue&type=script&lang=js&"
export * from "./MailLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d11521",
  null
  
)

export default component.exports